// extracted by mini-css-extract-plugin
module.exports = {"root":"ShowMoreButton-root-24e45d531abed7fdbdd62d6b308084ee"};